import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { init } from '~/src/utils/analytics';

init();

ReactDOM.render(<App />, document.querySelector('#app'));
